var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./CardOptions.module.scss";
export var TitledDescription = function (_a) {
    var title = _a.title, description = _a.description;
    return (_jsxs("div", __assign({ className: styles.titledDescription }, { children: [_jsx("div", __assign({ className: styles.cardTitle }, { children: title })), _jsx("div", __assign({ className: styles.cardDescription }, { children: description }))] })));
};
var Card = function (_a) {
    var children = _a.children, format = _a.format, select = _a.select, showInfoBar = _a.showInfoBar;
    return (_jsxs("div", __assign({ className: "".concat(styles.card, " ").concat(format), onClick: select }, { children: [_jsxs("div", __assign({ className: styles.circle, style: {
                    border: "2px solid ".concat(showInfoBar ? "var(--act-dark)" : "var(--grey-color-60)"),
                } }, { children: [_jsx("div", { className: styles.dot }), " "] })), _jsxs("div", __assign({ className: styles.content }, { children: [children, " "] }))] })));
};
export var CardOptions = function (_a) {
    var options = _a.options, _b = _a.selection, selected = _b[0], setSelected = _b[1], showInfoBar = _a.showInfoBar;
    return (_jsx("div", __assign({ className: styles.cardOptions }, { children: options.map(function (option, index) { return (_jsx(Card, __assign({ format: selected === index ? styles.selected : styles.unselected, select: function () {
                setSelected(index);
            }, showInfoBar: showInfoBar }, { children: option }), index)); }) })));
};
